import onboardingSlice from './slice';
import {
  createWorker,
  searchWorker,
  createPassword,
  acceptBiometricConsent,
  uploadImageToS3,
  fetchWorkerDetails,
  fetchWorkerExistingConsentForms,
  updateWorker,
  uploadGovernmentDocumentFiles,
  deleteGovernmentDocumentFile,
  addCertification,
  getCertificationDetails,
  updateCertification,
  assignWorkerToCompanies,
  assignExistingWorkerToCompanies,
  fetchAssignedCompanies,
  deleteCertification,
  uploadSignatureToS3,
  submitConsentAcceptances,
  fetchWorkerConsentAcceptances,
  acceptCustomConsentForms,
  acceptProject,
  fetchAllCertifications,
  fetchCertificationGroups,
  sendPinForPiiVerification,
  verifyPiiPin,
  getWorkerRequirementStatus,
  getRevokeBadgeInfo,
  getPositiveDrugTestResults,
} from './actions';

export const {
  setOnboarding,
  setHasReachedConsentForm,
  addVisitedWizardStep,
  setConsentAcceptance,
  setTemp,
  addGovernmentDocumentFile,
  setWorkerPIIPinInformation,
  setDbMetadata,
  resetOnboardingState,
  resetTempOnboardingData,
  resetAssignedCompanies,
} = onboardingSlice.actions;

export {
  createWorker,
  searchWorker,
  createPassword,
  acceptBiometricConsent,
  uploadImageToS3,
  fetchWorkerDetails,
  fetchWorkerExistingConsentForms,
  updateWorker,
  uploadGovernmentDocumentFiles,
  deleteGovernmentDocumentFile,
  addCertification,
  getCertificationDetails,
  updateCertification,
  assignWorkerToCompanies,
  assignExistingWorkerToCompanies,
  fetchAssignedCompanies,
  deleteCertification,
  uploadSignatureToS3,
  submitConsentAcceptances,
  fetchWorkerConsentAcceptances,
  acceptCustomConsentForms,
  acceptProject,
  fetchAllCertifications,
  fetchCertificationGroups,
  sendPinForPiiVerification,
  verifyPiiPin,
  getWorkerRequirementStatus,
  getRevokeBadgeInfo,
  getPositiveDrugTestResults,
};

export default onboardingSlice.reducer;
